import { z } from 'zod/v4';

export const PnpFileInsertRuntype = z.object({
    assembly_id: z.string(),
    file_name: z.string(),
});

export const PnpUploadFailedURLResponseRuntype = z.object({
    data: z.object({
        url: z.string(),
    }),
});

export const PnpFileResponseRuntype = z.object({
    id: z.string(),
    url: z.string(),
});

export const PnpColumnRuntype = z.enum(['Side', 'Designator']);

export const PnpSideRuntype = z.enum(['Top', 'Bottom']);

export type PnpSideDTO = z.infer<typeof PnpSideRuntype>;

export const UnableToParseCellWarningRuntype = z.object({
    type: z.literal('UnableToParseCell'),
    data: z.object({
        column_type: PnpColumnRuntype,
        //0th index.
        row: z.number(),
        //0th index.
        col: z.number(),
    }),
});

export const DesignatorMissingWarningRuntype = z.object({
    type: z.literal('DesignatorMissing'),
    data: z.number(),
});

export const ColumnMissingWarningRuntype = z.object({
    type: z.literal('ColumnMissing'),
    data: PnpColumnRuntype,
});

export const DuplicateDesignatorDataWarningRuntype = z.object({
    type: z.literal('DuplicateDesignatorData'),
    data: z.string(),
});

export const VaryingColumnNumberWarningRuntype = z.object({
    type: z.literal('VaryingColumnNumber'),
    data: z.object({
        row: z.number(),
        col_count: z.number(),
        expected_col_count: z.number(),
    }),
});

export const WarningRuntype = z.union([
    UnableToParseCellWarningRuntype,
    DesignatorMissingWarningRuntype,
    ColumnMissingWarningRuntype,
    DuplicateDesignatorDataWarningRuntype,
    VaryingColumnNumberWarningRuntype,
]);

export const ColumnMappingRuntype = z.object({
    side: z.number().nullable(),
    designator: z.number().nullable(),
});

export const PnpItemRuntype = z.object({
    id: z.string(),
    pnp_file: z.string(),
    designator: z.string(),
    side: PnpSideRuntype.nullable(),
    design_item: z.string().nullable(),
    mounting: z.string().nullable(),
});
export type PnpItemDTO = z.infer<typeof PnpItemRuntype>;

export const PnpFileStateRuntype = z.enum(['Created', 'Uploaded', 'Parsed']);

export const PnpFileRuntype = z.object({
    id: z.string(),
    assembly_id: z.string(),
    file_name: z.string(),
    state: PnpFileStateRuntype,
    column_mapping: ColumnMappingRuntype.nullable(),
    url: z.string().nullable(),
});
export type PnpFileDTO = z.infer<typeof PnpFileRuntype>;

export const BulkPnpItemsResponseRuntype = z.object({
    warnings: z.array(WarningRuntype),
    items: z.array(PnpItemRuntype),
});
export type BulkPnpItemsResponseDTO = z.infer<typeof BulkPnpItemsResponseRuntype>;

export const NoPnpUploadedResponseRuntype = z.object({
    type: z.literal('PnpNotUploaded'),
});

export const PnpUploadedResponseRuntype = z.object({
    type: z.literal('PnpUploaded'),
    data: BulkPnpItemsResponseRuntype,
});

export const PnpUploadedButNotImportedResponseRuntype = z.object({
    type: z.literal('PnpUploadedButNotImported'),
    data: PnpFileRuntype,
});

export const CheckedBulkPnpItemsResponseRuntype = z.union([
    NoPnpUploadedResponseRuntype,
    PnpUploadedResponseRuntype,
    PnpUploadedButNotImportedResponseRuntype,
]);
export type CheckedBulkPnpItemsResponseDTO = z.infer<typeof CheckedBulkPnpItemsResponseRuntype>;

// Bulk import types
export const PnpImportItemRuntype = z.object({
    designator: z.string(),
    side: z.string(),
});

export const PnpBulkImportRequestRuntype = z.object({
    items: z.array(PnpImportItemRuntype),
    assemblyId: z.string(),
});

export const PnpBulkImportResponseRuntype = z.object({
    items: z.array(PnpItemRuntype),
});
